import { inject, InjectionToken, Provider } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { RouteDataKey } from 'app/static/route-data-key.enum'

import { Header } from './generated/api-types'

export const HEADER_DATA = new InjectionToken<Header>(ngDevMode ? 'HEADER_DATA' : '')

export function provideHeaderFromResolverRouteData(): Provider[] {
  return [{ provide: HEADER_DATA, useFactory: () => inject(ActivatedRoute).snapshot.data[RouteDataKey.HEADER] }]
}
